import React from "react";
import backgroundImage from "../images/map_indonesia.png";
import backgroundImageProject1 from "../images/project1.jpg";
import backgroundImageProject2 from "../images/project2.jpg";
import { Link } from 'react-router-dom'
import useMode from '../hooks/useMode'
import { FaStar, FaMedal } from 'react-icons/fa';
import { BsPeopleFill } from "react-icons/bs";
import { icons } from "react-icons";


function HomeScreen() {

    const { darkMode, setMode } = useMode();


    const heroSectionStyle = {
        position: "relative",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "75vh",
    };

    const projectBackground1 = {
        position: "relative",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImageProject1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    }

    const projectBackground2 = {
        position: "relative",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImageProject2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    }

    const textStyle = {
        position: "relative",
        zIndex: 1, // Ensure the text is displayed in front of the image
        color: "white",
        textAlign: "center",
    };

    return (
        <>
            <div className="mb-16">
                <div className="hero-section relative h-[50vh]" style={heroSectionStyle}>
                    <div className="flex items-center justify-center h-full">
                        <div style={textStyle}>
                            <h1 className="text-4xl md:text-6xl font-semibold">Indonesia's Global Socio-Economic</h1>
                            <h1 className="text-4xl md:text-6xl font-semibold">Position Research Center</h1>
                        </div>
                    </div>
                </div>
                <div className="mt-8 container mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center p-4">
                        <div className="items-center text-center">
                            {darkMode ? (
                                <img className="w-4/5" src="igsp-logo-dark-mode.png" alt="" />
                            ) : (
                                <img className="w-4/5" src="igsp-logo-light-mode.png" alt="" />
                            )}
                        </div>
                        <div className="text-left md:ml-12 text-justify">
                            <div className="grid grid-cols-12 items-center">
                                <div className="col-span-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 md:w-24 md:h-24 lg:w-32 lg:h-32" viewBox="0 0 100 100" fill="none">
                                        <path d="M60.9375 87.5C60.9375 88.7432 60.4436 89.9355 59.5646 90.8145C58.6855 91.6936 57.4932 92.1875 56.25 92.1875H43.75C42.5068 92.1875 41.3145 91.6936 40.4354 90.8145C39.5564 89.9355 39.0625 88.7432 39.0625 87.5C39.0625 86.2568 39.5564 85.0645 40.4354 84.1854C41.3145 83.3064 42.5068 82.8125 43.75 82.8125H56.25C57.4932 82.8125 58.6855 83.3064 59.5646 84.1854C60.4436 85.0645 60.9375 86.2568 60.9375 87.5ZM50 45.3125C51.2361 45.3125 52.4445 44.9459 53.4723 44.2592C54.5001 43.5724 55.3012 42.5963 55.7742 41.4543C56.2473 40.3122 56.3711 39.0556 56.1299 37.8432C55.8887 36.6308 55.2935 35.5171 54.4194 34.6431C53.5453 33.769 52.4317 33.1737 51.2193 32.9326C50.0069 32.6914 48.7503 32.8152 47.6082 33.2882C46.4662 33.7613 45.4901 34.5624 44.8033 35.5902C44.1166 36.618 43.75 37.8264 43.75 39.0625C43.75 40.7201 44.4085 42.3098 45.5806 43.4819C46.7527 44.654 48.3424 45.3125 50 45.3125ZM88.8789 61.2109L84.0508 82.9414C83.7667 84.2384 83.1551 85.441 82.2744 86.4346C81.3936 87.4281 80.2731 88.1795 79.0195 88.6172C78.1798 88.9122 77.2962 89.0628 76.4062 89.0625C74.6641 89.061 72.9732 88.4735 71.6055 87.3945L61.3945 79.6875H38.6055L28.3945 87.3984C27.0263 88.476 25.3354 89.0621 23.5938 89.0625C22.7035 89.0615 21.8199 88.9096 20.9805 88.6133C19.7269 88.1756 18.6064 87.4242 17.7256 86.4306C16.8449 85.4371 16.2333 84.2345 15.9492 82.9375L11.1211 61.2109C10.8651 60.0448 10.8784 58.8357 11.16 57.6755C11.4416 56.5153 11.984 55.4346 12.7461 54.5156L23.6172 41.4687C24.0331 36.5804 25.1718 31.7808 26.9961 27.2265C32.1797 14.2383 41.4492 6.09374 45.2148 3.1953C46.5843 2.13418 48.2676 1.55835 50 1.55835C51.7324 1.55835 53.4157 2.13418 54.7852 3.1953C58.5352 6.09374 67.8203 14.2383 73.0039 27.2265C74.8282 31.7808 75.9669 36.5804 76.3828 41.4687L87.2539 54.5156C88.016 55.4346 88.5584 56.5153 88.84 57.6755C89.1216 58.8357 89.1349 60.0448 88.8789 61.2109ZM39.7617 70.3125H60.2383C67.8594 56.3672 69.2227 43.0547 64.2969 30.7031C60.3125 20.7031 53.2031 14.0234 50 11.375C46.7969 14.0234 39.6875 20.7031 35.7031 30.7031C30.7734 43.0547 32.1406 56.3672 39.7617 70.3125ZM30.9531 73.7187C27.8364 67.9259 25.6084 61.6975 24.3438 55.2422L20.4375 59.9297L24.5703 78.539L30.9531 73.7187ZM79.5586 59.9258L75.6523 55.2383C74.3877 61.6936 72.1596 67.922 69.043 73.7148L75.4219 78.5312L79.5586 59.9258Z" fill="#192F59" />
                                    </svg>
                                </div>
                                <div className="col-span-9">
                                    <h2 className="text-2xl md:text-4xl text-primary-400 font-bold mb-2 md:mt-0 mt-4">Mission</h2>
                                    <p className="text-base md:text-[20px] text-gray-700">"Provide data analytical and information technological resources about Indonesia's Global Socioeconomic Position through rigorous research and the development of impactful insights as relevant to economic policy, business development, and public debate”</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-8 md:mt-16 container sm:mx-auto justify-center max-w-5xl">
                    <h2 className="text-2xl md:text-4xl text-primary-400 font-bold mb-2">Our Values</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16 p-4">
                        <div className="flex flex-col items-center">
                            <FaStar className="text-[#f59e0b] text-5xl " />
                            <p className="mt-2 text-center text-[20px] font-semibold">Guiding-Tenets</p>
                            <p className="text-base md:text-[18px] items-center md:mt-4 mt-2">We consider religious diversity, just and civillized humanity, unity, democracy, and social justice irrefutable drivers of Indonesia's prosperity, peace, and stability, in line with the ideals of Pancasila.</p>
                        </div>
                        <div className="flex flex-col items-center">
                            <FaMedal className="text-[#f59e0b] text-5xl" />
                            <p className="mt-2 text-center text-[20px] font-semibold">Excellence</p>
                            <p className="text-base md:text-[18px] text-center md:mt-4 mt-2">Strive for intellectual rigor, precision, and innovation in all aspects of our work.</p>
                        </div>
                        <div className="flex flex-col items-center">
                            <BsPeopleFill className="text-[#f59e0b] text-5xl" />
                            <p className="mt-2 text-center text-[20px] font-semibold">Public Service</p>
                            <p className="text-base md:text-[18px] text-center md:mt-4 mt-2">Serve government, businesses, non-profit organizations, and local communities through collaboration.</p>
                        </div>
                    </div>
                </div>


                <div className="mt-8 md:mt-16 container mx-auto">
                    <h2 className="text-2xl md:text-4xl text-primary-400 font-bold mb-2">Our Projects</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 mt-6 gap-6 md:gap-12 items-center p-4">
                        <div className="relative h-[25vh] md:h-[30vh] rounded-lg" style={projectBackground1}>
                            <Link to="/project">
                                <div className="flex items-center justify-center h-full">
                                    <div style={textStyle}>
                                        <h1 className="text-2xl md:text-3xl font-semibold">Indonesia Global Socioeconomics</h1>
                                        <h1 className="text-2xl md:text-3xl font-semibold">Position Research Center</h1>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="relative h-[25vh] md:h-[30vh] rounded-lg" style={projectBackground2}>
                            <Link to="/globalbusiness">
                                <div className="flex items-center justify-center h-full">
                                    <div style={textStyle}>
                                        <h1 className="text-2xl md:text-3xl font-semibold">WEF'S Global Competitiveness Rating</h1>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="mt-8 md:mt-16 mb-16 container mx-auto">
                    <h2 className="text-2xl md:text-4xl text-primary-400 font-bold mb-2">Our Collaboration</h2>
                    <div className="mt-8 flex justify-center p-4">
                        <div className="grid grid-cols-2 gap-8 flex">
                            <div className="col-span-1 flex items-center justify-center">
                                <img className="h-[70px] md:h-[100px] w-auto" src={require("../images/logo-prasmul.png")} alt="" />
                            </div>
                            <div className="col-span-1 flex items-center justify-center">
                                <img className="h-10 md:h-20 w-auto" src={require("../images/largo.png")} alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="md:mt-8 container mx-auto">
                    <h1 className="text-2xl md:text-3xl font-bold text-primary-400">Lorem Ipsum</h1>
                    <div className="md:mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 p-4">
                        <div className="    rounded-lg overflow-hidden border border-gray-300 shadow-md">
                            <img className="h-40 w-full object-cover mb-4 rounded-t-lg" src={require("../images/img1.jpg")} alt="Image 1" />
                            <div className="p-4">
                                <p className="text-base text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                            </div>
                        </div>

                        <div className="    rounded-lg overflow-hidden border border-gray-300 shadow-md">
                            <img className="h-40 w-full object-cover mb-4 rounded-t-lg" src={require("../images/img2.jpg")} alt="Image 1" />
                            <div className="p-4">
                                <p className="text-base text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                            </div>
                        </div>

                        <div className="    rounded-lg overflow-hidden border border-gray-300 shadow-md">
                            <img className="h-40 w-full object-cover mb-4 rounded-t-lg" src={require("../images/img3.jpg")} alt="Image 1" />
                            <div className="p-4">
                                <p className="text-base text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                            </div>
                        </div>

                        <div className="    rounded-lg overflow-hidden border border-gray-300 shadow-md">
                            <img className="h-40 w-full object-cover mb-4 rounded-t-lg" src={require("../images/img4.jpg")} alt="Image 1" />
                            <div className="p-4">
                                <p className="text-base text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
}

export default HomeScreen;

